import { render } from "./service-manage.vue?vue&type=template&id=d4f2c06a&scoped=true&ts=true"
import script from "./service-manage.vue?vue&type=script&lang=ts"
export * from "./service-manage.vue?vue&type=script&lang=ts"

import "./service-manage.vue?vue&type=style&index=0&id=d4f2c06a&lang=scss&scoped=true"
import "./service-manage.vue?vue&type=style&index=1&id=d4f2c06a&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f2c06a"]])

export default __exports__